import Vue from 'vue';
import Router from 'vue-router';
import store from '../store'
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);
const router = new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      next()
      return
    }
    next('/')
  } else {
    next()
  }
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js